import React, { useEffect, useState } from "react";

//package import

import {
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  useTheme,
  Typography,
  Box,
  Toolbar,
  ListItem,
  Stack,
  Avatar,
} from "@mui/material";

import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { listItemButtonClasses } from "@mui/material/ListItemButton";
import AppBar from "@mui/material/AppBar";

import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import { LimospayTextIcon } from "../../../Svg";

// user routes

import {
  NAV_ROUTES,
  MainRoutes,
  ADMIN_ROUTES,
} from "../../../Services/Routes/App";

import DashTransactionIcon from "../../../Svg/DashTransactionIcon";
import {
  DashBoardIcon,
  AdminPaymentGatewaysICon,
  AdminServiceProviderICon,
  AdminUsersICon,
  AdminTransactionsICon,
  AdminWalletICon,
} from "../../../Svg";
import DashWalletIcon from "../../../Svg/DashWalletIcon";
import DashNotificationIcon from "../../../Svg/DashNotificationIcon";
import DashSettingIcon from "../../../Svg/DashSettingIcon";
import DashProfileIcon from "../../../Svg/DashProfileIcon";
import DashSupportIcon from "../../../Svg/DashSupportIcon";
import DashLogoutIcon from "../../../Svg/DashLogoutIcon";
import { color } from "@mui/system";
import { useDecodedToken } from "../../../Services/Routes/App/PrivateRouts";
import { USER_ROLES_ENUM } from "../../../Services/Enums";
// Constants

const sideList = [
  {
    id: 300,
    title: "Dashboard",
    icon: (color) => {
      return <DashBoardIcon color={color} />;
    },
    link: NAV_ROUTES?.dashboard,
  },

  {
    id: 301,
    title: "Transaction",
    icon: (color) => {
      return <DashTransactionIcon color={color} />;
    },
    link: NAV_ROUTES?.transaction,
  },
  {
    id: 307,
    title: "Wallet",
    icon: (color) => {
      return <DashWalletIcon color={color} />;
    },
    link: NAV_ROUTES?.wallet,
  },
  {
    id: 302,
    title: "Notifications",
    icon: (color) => {
      return <DashNotificationIcon color={color} />;
    },
    link: NAV_ROUTES?.notifications,
  },
  {
    id: 303,
    title: "Profile",
    icon: (color) => {
      return <DashProfileIcon color={color} />;
    },
    link: NAV_ROUTES?.profile,
  },
  {
    id: 304,
    title: "Support",
    icon: (color) => {
      return <DashSupportIcon color={color} />;
    },
    link: NAV_ROUTES?.support,
  },
  {
    id: 305,
    title: "Setting",
    icon: (color) => {
      return <DashSettingIcon color={color} />;
    },
    link: NAV_ROUTES?.setting,
  },
  {
    id: 306,
    title: "Logout",
    icon: (color) => {
      return <DashLogoutIcon color={color} />;
    },
    link: NAV_ROUTES?.logout,
  },
];

const adminSideList = [
  {
    id: 300,
    title: "Wallet",
    icon: (color) => {
      return <AdminWalletICon color={color} />;
    },
    link: ADMIN_ROUTES?.dashboard,
  },
  {
    id: 307,
    title: "Transactions",
    icon: (color) => {
      return <AdminTransactionsICon color={color} />;
    },
    link: ADMIN_ROUTES?.transaction,
  },
  {
    id: 302,
    title: "Users",
    icon: (color) => {
      return <AdminUsersICon color={color} />;
    },
    link: ADMIN_ROUTES?.users,
  },
  {
    id: 303,
    title: "Payment Gateways",
    icon: (color) => {
      return <AdminPaymentGatewaysICon color={color} />;
    },
    link: ADMIN_ROUTES?.payment_methods,
  },
  {
    id: 304,
    title: "Service Provider",
    icon: (color) => {
      return <AdminServiceProviderICon color={color} />;
    },
    link: ADMIN_ROUTES?.service_provider,
  },
  {
    id: 306,
    title: "Logout",
    icon: (color) => {
      return <DashLogoutIcon color={color} />;
    },
    link: ADMIN_ROUTES?.logout,
  },
];
export const InsideDrawer = () => {
  const location = useLocation();
  const theme = useTheme();
  const navigate = useNavigate();
  const user = useDecodedToken();

  const [list, setList] = useState([]);

  const addHandler = (sidebarText) => {
    if (sidebarText === "Logout") {
      localStorage.clear();
      navigate(MainRoutes?.root);
    }
  };

  useEffect(() => {
    if (user) {
      setList(
        user.role.includes(USER_ROLES_ENUM.user) ? sideList : adminSideList
      );
    }
  }, [user]);

  return (
    <Box>
      <Box padding={2}>
        <Typography
          color={"common.black"}
          variant="h4"
          fontWeight={"bold"}
          align="center"
        >
          <LimospayTextIcon width={"50"} height={"50"} />
        </Typography>
      </Box>
      <Box marginY={2}>
        {user?.role?.includes(USER_ROLES_ENUM.admin) && (
          <Stack bgcolor={"#D9D9D9"} py={1} pl={2} direction={"row"}>
            <Box bgcolor={"#D9D9D9"} padding={1} borderRadius={1.5}>
              <Avatar />
            </Box>
            <Box pl={2}>
              <Typography pt={0.8}>Micheal</Typography>
              <Typography
                sx={{
                  color: "#666666",
                  lineHeight: theme.spacing(1),
                }}
                variant="body2"
                component={"span"}
              >
                Admin
              </Typography>
            </Box>
          </Stack>
        )}
      </Box>

      <List>
        {list?.map((item, index) => {
          const isSelected = location?.pathname === item?.link;
          return (
            <NavLink
              key={`${item?.id}-user-route-${index}`}
              to={item?.link ? item?.link : "#"}
              style={{
                textDecoration: "none",
                color: "inherit",
              }}
              className={"active_link"}
            >
              <ListItemButton
                onClick={() => addHandler(item?.title)}
                sx={{
                  backgroundColor: "transparent",

                  padding: theme.spacing(1.5, 1.5, 1.5, 4),
                  [`&.${listItemButtonClasses.selected}`]: {},
                }}
                selected={isSelected}
              >
                <ListItemIcon>
                  {" "}
                  {item?.icon(isSelected && "#00008B")}
                </ListItemIcon>
                <ListItemText
                  primary={item?.title}
                  sx={{
                    color: isSelected ? "#00008B" : theme.palette.common.black,
                  }}
                />
              </ListItemButton>
            </NavLink>
          );
        })}
      </List>
    </Box>
  );
};
